<template>
    <div>
        <TitleAndExplanation v-if="title || explanation" :title="title" :explanation="explanation"/>
        <div class="input-field-container" >
            <div class="input-field">
                <label 
                    :class = "{ active: inputValue || isFocused }"
                    for = "text-input" 
                    v-if = "label !== ''"> {{ label }}</label>
                <textarea 
                    v-model = "inputValue"
                    id = "text-input"
                    :class = "{ hasvalue: inputValue !== null }"
                    :placeholder = "label !== '' ? placeholder : ''"
                    :rows = "rows"
                    @input = "emitInputValue"
                    @focus = "isFocused = true"
                    @blur = "isFocused = false"
                ></textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import TitleAndExplanation from '../common/TitleAndExplanation.vue';

    export default {
        name: 'InputText',
        components: {
            TitleAndExplanation
        },
        data() {
            return {
                inputValue: this.currentValue,
                isFocused: false       
            };
        },
        props: {
            placeholder: {
                type: String,
                default: ''
            },
            currentValue: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            rows: {
                type: Number,
                default: 2
            },
            explanation: {
                type: String,
                default: ''
            }
        },
        methods: {
            emitInputValue() {
                const value = this.inputValue;
                this.$emit('valueChanged', value);
            }
        }
    }
</script>

<style scoped>
    .input-field-container {
        width: 100%;
        position: relative;
        /* margin-top: 24px; */
    }
    .input-field {
        position: relative;
        width: 100%;
        margin: 20px 0;
    }
    .input-field textarea {
        resize: none;
        width: 100%;
        font-size: var(--font-size-inputs);
        font-family: "Avenir Next", sans-serif;
        font-weight: var(--font-weight-medium);
        outline: none;
        box-sizing: border-box;
        transition: border-color 0.2s ease;
        border: 1px solid var(--gray-light);
        border-radius: var(--border-radius);
        padding: 8px 16px;
    }
    .input-field textarea.hasvalue,
    .input-field textarea:focus {
        padding: 20px 15px 10px;
    }
    .input-field textarea::placeholder {
        color: var(--gray);
        font-size: 14px;
    }    
    .input-field label {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        background: transparent;
        padding: 0 5px;
        font-size: 14px;
        color: var(--gray);
        pointer-events: none;
        transition: all 0.2s ease;
    }
    .input-field label.active {
        top: 12px;
        font-size: 10px;
        color: var( --black);
    }

    /* MOVIL */
    @media (max-width: 768px) {
        /* .input-field {
            width: 100%;
        } */
    }

</style>
